import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AccountRequestsState } from "../../models/mp-admin/account-requests-state";

const initialState: AccountRequestsState = {
	loading: true,
	requests: []
};

// List of actions that should remove a request from state
const removeRequestActions = [
	MpAdminActions.consumer.activateSuccess,
	MpAdminActions.vendorActivation.activateSuccess,
	MpAdminActions.consumer.denySuccess,
	MpAdminActions.vendorActivation.denySuccess
];

const reducer = createReducer(
	initialState,
	on(MpAdminActions.accountRequests.getApi, (state) => ({
		...state,
		loading: true
	})),

	on(MpAdminActions.accountRequests.getSuccess, (state, action) => _.omit(action, "type")),

	on(MpAdminActions.accountRequests.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),

	on(...removeRequestActions, (state, { id }) => {
		if (!state.requests) {
			return state;
		}
		const requests = state.requests.filter((request) => request.accountId !== id);
		return {
			...state,
			requests
		};
	})
);

export function accountRequestsReducer(
	state: AccountRequestsState | undefined,
	action: Action
): AccountRequestsState {
	return reducer(state, action);
}
